import React from "react";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Box } from "@mui/material";
import ApiButton from "../components/customComponent/ApiButton"; // Assuming this path is correct
import { flex } from "@mui/system";

const ExamDetailsColumns = [
    // S.No. column with a fixed width, as it doesn't need to expand.
    {
        field: "sNo",
        headerName: "S. No.",
        width: 70,
         align: 'center',              // ✅ Center cell content
        headerAlign: 'center', 
        flex: 0.5,
    },

    // Flexible columns that will share the available space.
    {
        field: "centerCode",
        headerName: "Center Code",
        minWidth: 140,
         align: 'center',              // ✅ Center cell content
        headerAlign: 'center', 
        flex: 1,
    },
    {
        field: "centerName",
        headerName: "Center Name",
        minWidth: 200,
         align: 'center',              // ✅ Center cell content
        headerAlign: 'center', 
        flex: 1, // Given more weight to accommodate longer center names.
    },
    {
        field: "shiftTime",
        headerName: "Shift Time",
        minWidth: 150,
         align: 'center',              // ✅ Center cell content
        headerAlign: 'center', 
        flex: 1,
    },

    // Columns with numeric or static data can remain fixed-width.
    {
        field: "totalStudents",
        headerName: "Total Candidates",
        width: 150,
         align: 'center',              // ✅ Center cell content
        headerAlign: 'center', 
    },
    {
   field: 'attendedStudents',
   align: 'center',              // ✅ Center cell content
   headerAlign: 'center',
   headerName: 'Attendance',
   width: 150,
 },
    {
        field: "presentStudents",
        headerName: "Present / Absent",
        width: 150,
         align: 'center',              // ✅ Center cell content
        headerAlign: 'center', 
        renderCell: (params) => {
            const { totalStudents, presentStudents } = params.row;
            return `${presentStudents} / ${totalStudents - presentStudents}`;
        },
    },
    // For L&T
   { 
    field: "apiSyncCount", 
    headerName: "API Sync Count", 
    width: 150,
    align: 'center',
    headerAlign: 'center',
    // Change this line:
    renderCell: (params) => {
  console.log("Row Data:", params.row); // This will show you exactly what keys exist
  return params.row?.apiSyncCount ?? 0;
}
},
    {
        field: "centerStatus",
        headerName: "Center Status",
        width: 150,
         align: 'center',              // ✅ Center cell content
        headerAlign: 'center', 
        renderCell: (params) => {
            const status = params.row.centerStatus;
            return (
                <Box
                    sx={{
                        width: '100%', // Ensure the box fills the cell
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    {status ? (
                        <ApiButton
                            rollNumbers={params.row.presentUnenrolledRollNumbers}
                            centerCode={params.row.centerCode}
                        />
                    ) : (
                        <CheckCircleOutlineIcon
                            sx={{ color: "#2e7d32" }}
                        />
                    )}
                </Box>
            );
        },
    },
];

export default ExamDetailsColumns;